import SwapHorizOutlinedIcon from '@material-ui/icons/SwapHorizOutlined';

import List from './List';

export default {
  list: List,
  icon: SwapHorizOutlinedIcon,
};
